import bootbox from 'bootbox';
import Dropzone from 'dropzone';

function reloadPage($btn, toggle) {
  if (typeof toggle === 'undefined') {
    toggle = true;
  }

  let valueEditable = toggle ? 0 : 1;
  let valueNotEditable = toggle ? 1 : 0;
  let edit = $('#conPage').data('editable') === 1 ? valueEditable : valueNotEditable;

  let functionParams = {
    page_id: $('input[name=page_id]').val(),
    edit: parseInt(edit)
  };

  let ajaxParams = {
    sourceEl: $btn,
    effectTarget: $btn,
    onSuccess: function (response) {
      $('#conPage').replaceWith(response.content);
    }
  };

  App.Helper.ajaxCall('page', functionParams, ajaxParams);
}

let timersComments = {};
function initCommentTimer(element_id)
{
  if (typeof timersComments[element_id] === "undefined" || timersComments[element_id] === false) {
    timersComments[element_id] = true;
    window.setTimeout(() =>
    {
      timersComments[element_id] = false;
      updateComments(element_id);
    }, 10000);
  }
}

function updateComments(element_id)
{
  let functionParams = {
    element_id: element_id
  };

  let ajaxParams = {
    onSuccess: function (response) {
      let comments = $.parseJSON(response.content);

      let $element = $('#element' + element_id);
      let $elementComments = $('#elementComments' + element_id);
      let $comments = $elementComments.find('.comments').first();

      $comments.empty();

      let html = '';
      $.each(comments, (i, comment) => {
        let $comment = $('<div class="comment"></div>');
        let $text = $('<div class="text"></div>');
        let $user = $('<div class="user"></div>');
        let $created = $('<div class="created"></div>');

        $text.text(comment.text);
        $user.text(comment.name);
        $created.text(comment.created_at);

        $comment
          .append($user)
          .append($created)
          .append($text)
        ;

        $comments.append($comment);
      });

      $element.find(".countComments").text(comments.length);

      if ($elementComments.is(':visible')) {
        initCommentTimer(element_id);
      }
    }
  };

  App.Helper.ajaxCall('page_element_comments', functionParams, ajaxParams);
}

$(document).ready(function () {
  if ($('#btnPageElementNew').length === 0) {
    return;
  }

  $('#app').on('click', '#btnPageElementNew', function () {
    let $btn = $('#btnPageElementNew');

    let functionParams = {};

    let ajaxParams = {
      sourceEl: $btn,
      effectTarget: $btn,
      onSuccess: function (response) {
        let $con = $(response.content);

        let $frm = $con.find('form').first();
        let $frmDropzone = $con.find('form.dropzone').first();

        let dialog = bootbox.dialog({
          title: App.Lang.get('add_new_element'),
          message: $con,
          buttons: {
            cancel: {
              label: App.Lang.get('cancel'),
              className: 'btn-secondary'
            },
            ok:
              {
                label: App.Lang.get('save'),
                className: 'btn-primary',
                callback: function (event) {
                  let $btnOk = $(event.target);

                  if ($frm.valid()) {
                    let type = parseInt($frm.find('#ddlModalType').val());
                    let text = $frm.find('.showType' + type + ' .elText').val();
                    let layout_image = parseInt($frm.find('#ddlModalImageLayout').val());

                    let functionParams = {
                      page_id: $('input[name=page_id]').val(),
                      type: type,
                      text: text,
                      layout_image: layout_image,
                      upload_page_ids: $frm.find('.txtUploadPageIds').serialize()
                    };

                    let ajaxParams = {
                      sourceEl: $btnOk,
                      effectTarget: $btnOk,
                      onSuccess: function (response) {
                        dialog.modal('hide');
                        App.Helper.showMessageSuccess(response.message);
                        reloadPage($btnOk, false);
                      }
                    };

                    App.Helper.ajaxCall('element_add', functionParams, ajaxParams);
                  }

                  return false;
                }
              }
          },
          onShow: function (e) {
            $frm.find('#ddlModalType').on('change', function () {
              let $ddl = $(this);
              $con.find('.toggleByType').hide();
              $con.find('.showType' + $ddl.val()).show();
            }).trigger('change');

            let config = $.extend({
              maxFiles: 20,
              acceptedFiles: 'image/*',
              maxFilesize: 20, // MB
              init: function () {
                this.on('sending', function (file, xhr, formData) {
                  formData.append('page_id', $('input[name=page_id]').val());
                });
              },
              error: function (file, errorMessage) {
                $(file.previewElement).addClass("error");
                bootbox.alert({
                  message: errorMessage,
                  size: 'small'
                });
              },
              success: function (response) {
                let upload_page_id = response.xhr.response;
                $frm.append(
                  '<input type="hidden" class="txtUploadPageIds" name="upload_page_ids[]" value="' + upload_page_id + '" />');
              }
            }, App.Lang.getLangPackDropzone());

            new Dropzone($frmDropzone.get(0), config);
          }
        });
      }
    };

    App.Helper.ajaxCall('element_form', functionParams, ajaxParams);
  });

  $('#app').on('click', '#btnPageSave', function () {
    let $btn = $(this);
    let $frm = $btn.parents('form').first();

    if ($frm.valid()) {
      let functionParams = {
        page_id: $('input[name=page_id]').val(),
        data: $frm.serialize()
      };

      let ajaxParams = {
        sourceEl: $btn,
        effectTarget: $btn,
        onSuccess: function () {
          reloadPage($btn);
        }
      };

      App.Helper.ajaxCall('page_content_save', functionParams, ajaxParams);
    }
  });

  $('#app').on('click', '#btnPageCancel', function () {
    let $btn = $(this);
    reloadPage($btn);
  });

  $('#app').on('click', '#btnPageEdit', function () {
    let $btn = $(this);
    reloadPage($btn);
  });

  $('#app').on('click', '.btnLike', function () {
    let $btn = $(this);
    let $element = $btn.parents('.element').first();

    let functionParams = {
      element_id: $element.data('id')
    };

    let ajaxParams = {
      sourceEl: $btn,
      effectTarget: $btn,
      onSuccess: function () {
        reloadPage($btn, false);
      }
    };

    App.Helper.ajaxCall('page_element_like', functionParams, ajaxParams);
  });

  $('#app').on('click', '.btnMoveUp', function () {
    let $btn = $(this);
    let $element = $btn.parents('.element').first();

    let functionParams = {
      element_id: $element.data('id')
    };

    let ajaxParams = {
      sourceEl: $btn,
      effectTarget: $btn,
      onSuccess: function () {
        reloadPage($btn, false);
      }
    };

    App.Helper.ajaxCall('page_element_move_up', functionParams, ajaxParams);
  });

  $('#app').on('click', '.btnMoveDown', function () {
    let $btn = $(this);
    let $element = $btn.parents('.element').first();

    let functionParams = {
      element_id: $element.data('id')
    };

    let ajaxParams = {
      sourceEl: $btn,
      effectTarget: $btn,
      onSuccess: function () {
        reloadPage($btn, false);
      }
    };

    App.Helper.ajaxCall('page_element_move_down', functionParams, ajaxParams);
  });

  $('#app').on('click', '.btnComment', function ()
  {
    let $btn = $(this);
    let $element = $btn.parents('.element').first();
    let $elementComments = $element.find('.elementComments').first();

    if ($elementComments.is(':visible')) {
      $elementComments.slideUp();
    } else {
      $elementComments.slideDown();
      updateComments($element.data('id'));
    }
  });

  $('#app').on('click', '.btnCommentSend', function ()
  {
    let $btn = $(this);
    let $element = $btn.parents('.element').first();

    let functionParams = {
      element_id: $element.data('id'),
      text: $element.find('.txtaComment').val()
    };

    let ajaxParams = {
      sourceEl: $btn,
      effectTarget: $btn,
      onSuccess: function () {
        $element.find('.txtaComment').val('');
        updateComments($element.data('id'));
      }
    };

    App.Helper.ajaxCall('page_element_comment', functionParams, ajaxParams);
  });

  $('#app').on('keydown', '.txtaComment', function (e) {
    let $txta = $(this);
    let $element = $txta.parents('.element').first();
    if (e.ctrlKey && e.keyCode === 13) {
      $element.find('.btnCommentSend').trigger('click');
    }
  });

});
